import { render, staticRenderFns } from "./tabsView.vue?vue&type=template&id=052db56c&scoped=true"
import script from "./tabsView.vue?vue&type=script&lang=js"
export * from "./tabsView.vue?vue&type=script&lang=js"
import style0 from "./tabsView.vue?vue&type=style&index=0&id=052db56c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052db56c",
  null
  
)

export default component.exports